import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * Schema.org JSON-LD for LocalBusiness — boosts SEO local & Google Maps integration.
 * Inserted on the home page only (most relevant business signal).
 *
 * Reference: https://schema.org/LocalBusiness + https://developers.google.com/search/docs/appearance/structured-data/local-business
 */
export default function LocalBusinessSchema() {
  const data = {
    "@context": "https://schema.org",
    "@type": ["LocalBusiness", "EventVenue"],
    "@id": "https://flexi-location.be/#business",
    "name": "Flexi-location",
    "description": "Centre d'affaires à Woluwe-Saint-Lambert : bureaux, salles de réunion et espaces de coworking à louer à l'heure, à la journée ou à la semaine. Réservation en ligne avec accès par code envoyé par email.",
    "url": "https://flexi-location.be",
    "image": "https://customer-assets.emergentagent.com/job_instant-access-space/artifacts/jtfp03jx_Flexic.jpg",
    "logo": "https://customer-assets.emergentagent.com/job_instant-access-space/artifacts/jtfp03jx_Flexic.jpg",
    "email": "info@flexi-location.be",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "304 Chaussée de Stockel",
      "addressLocality": "Woluwe-Saint-Lambert",
      "postalCode": "1200",
      "addressRegion": "Région de Bruxelles-Capitale",
      "addressCountry": "BE"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 50.84178,
      "longitude": 4.45079
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
        "opens": "06:00",
        "closes": "22:00"
      }
    ],
    "priceRange": "€€",
    "currenciesAccepted": "EUR",
    "paymentAccepted": "Card, Bancontact, PayPal",
    "areaServed": [
      { "@type": "City", "name": "Bruxelles" },
      { "@type": "City", "name": "Woluwe-Saint-Lambert" },
      { "@type": "City", "name": "Woluwe-Saint-Pierre" },
      { "@type": "City", "name": "Etterbeek" },
      { "@type": "City", "name": "Kraainem" }
    ],
    "amenityFeature": [
      { "@type": "LocationFeatureSpecification", "name": "Wifi haut débit fibre", "value": true },
      { "@type": "LocationFeatureSpecification", "name": "Parking disque bleu", "value": true },
      { "@type": "LocationFeatureSpecification", "name": "Climatisation", "value": true },
      { "@type": "LocationFeatureSpecification", "name": "Accès 7j/7 par code", "value": true },
      { "@type": "LocationFeatureSpecification", "name": "Café, thé, eau inclus", "value": true }
    ],
    "publicAccess": true,
    "isAccessibleForFree": false,
    "knowsLanguage": ["fr", "nl", "en"],
    "hasMap": "https://www.google.com/maps/search/?api=1&query=Flexi-location+304+Chauss%C3%A9e+de+Stockel+1200+Bruxelles",
    "potentialAction": {
      "@type": "ReserveAction",
      "name": "Réserver un espace",
      "target": "https://flexi-location.be/plan"
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(data)}</script>
    </Helmet>
  );
}
